import React, { useEffect, useRef, useState } from 'react';
import { sizedPhotoUrl } from '../utilities/photoVariants';

// Loads the sized WebP copy; falls back to the original if the copy is missing.
export default function SizedImg({ src, photoWidth = 400, alt = '', ...rest }) {
  const sized = sizedPhotoUrl(src, photoWidth);
  const [failed, setFailed] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    setFailed(false);
    const img = ref.current;
    if (img && sized && img.complete && img.naturalWidth === 0) setFailed(true);
  }, [src, sized]);
  const useOriginal = failed || !sized;
  return (
    <img
      ref={ref}
      src={useOriginal ? src : sized}
      alt={alt}
      onError={useOriginal ? undefined : () => setFailed(true)}
      {...rest}
    />
  );
}
